import monitorService from '@/services/monitor.service';

export default {
    name: "HomeComponent",
    components: {},
    data() {
        return {
            telemetryTime: 0,
            telemetryCount: 0,
            stateMachineTime: 0,
            stateMachineCount: 0,
            communicationDataCount: 0,
            charts: [],
            chartKey: "",
            intervalInstance: null,
            tracksToProcess:0
        };
    },
    async mounted() {
        this.updateDashboards();
        this.intervalInstance = setInterval(this.updateDashboards, 60000);
    },
    beforeDestroy() {
        clearInterval(this.intervalInstance);
    },
    methods: {
        async updateDashboards() {
            const summary = await monitorService.getSummary();
            this.telemetryTime = summary.telemetryTime;
            this.telemetryCount = summary.telemetryCount;
            this.stateMachineTime = summary.stateMachineTime;
            this.stateMachineCount = summary.stateMachineCount;
            this.communicationDataCount = summary.communicationDataCount;
            this.charts = summary.chart;
            this.chartKey = Math.random().toString(36).slice(2, 7);
            this.tracksToProcess = summary.tracksToProcess;
        }
    }
};
